export const DEFAULT_ERROR_MESSAGE = "An error occurred";
export const BASE_URL_ERROR_MESSAGE =
  "`baseUrl` is required when using relative path.";
